import { QuotesIcon } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

const STAT_VALUES = [
  { id: "ai-modes", value: "8" },
  { id: "live-leagues", value: "3" },
  { id: "languages", value: "2" },
  { id: "ask-anytime", value: "24/7" },
];

const COPY = {
  en: {
    stats: ["AI modes per game", "Leagues with live game data", "Languages: English & Spanish", "Ask Gamly, any question"],
    stories: [
      { quote: "I finally get why the manager pulls a pitcher. Gamly explains it before the announcers do.", who: "Casual baseball fan", tag: "Understand every play" },
      { quote: "My friends couldn't make the game, so Gamly was my watch buddy. It argued with my hot takes.", who: "Lakers season-ticket fan", tag: "Never watch a game alone" },
      { quote: "The win-probability swings and fantasy alerts made a blowout worth watching to the end.", who: "Fantasy league commissioner", tag: "Smarter than the broadcast" },
    ],
    disclaimer: "Stories are illustrative examples of how fans use Gamly, not quotes from real users.",
  },
  es: {
    stats: ["Modos de IA por partido", "Ligas con datos en vivo", "Idiomas: inglés y español", "Pregúntale a Gamly lo que sea"],
    stories: [
      { quote: "Por fin entiendo por qué el mánager saca al pitcher. Gamly lo explica antes que los narradores.", who: "Fan casual del béisbol", tag: "Entiende cada jugada" },
      { quote: "Mis amigos no pudieron venir al partido, así que Gamly fue mi compañero. Hasta discutió mis opiniones picantes.", who: "Abonado de los Lakers", tag: "Nunca veas un partido solo" },
      { quote: "Los cambios en la probabilidad de victoria y las alertas de fantasy hicieron que valiera la pena ver una paliza hasta el final.", who: "Comisionado de liga fantasy", tag: "Más inteligente que la transmisión" },
    ],
    disclaimer: "Las historias son ejemplos ilustrativos de cómo los fans usan Gamly, no citas de usuarios reales.",
  },
};

export default function FanStories() {
  const { lang } = useLang();
  const c = COPY[lang];
  return (
    <div data-testid="fan-stories">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-md overflow-hidden mb-10">
        {STAT_VALUES.map((s, i) => (
          <div key={s.id} className="bg-[#080808] px-6 py-7" data-testid={`stat-${s.id}`}>
            <p className="font-num text-5xl font-black text-white">{s.value}</p>
            <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-white/45 mt-1">{c.stats[i]}</p>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {c.stories.map((s, i) => (
          <figure
            key={COPY.en.stories[i].who}
            data-testid={`fan-story-${i}`}
            className="fade-up p-6 rounded-md bg-[#121212] border border-white/10 flex flex-col"
            style={{ animationDelay: `${i * 120}ms` }}
          >
            <QuotesIcon weight="fill" size={26} className="text-[#0A84FF] mb-3" />
            <blockquote className="text-base text-white/85 font-medium leading-relaxed flex-1">{s.quote}</blockquote>
            <figcaption className="mt-5 flex items-center justify-between gap-3">
              <span className="text-xs font-bold uppercase tracking-wider text-white/50">{s.who}</span>
              <span className="text-[10px] font-black uppercase tracking-[0.14em] text-[#32D74B] text-right">{s.tag}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <p className="mt-4 text-[11px] text-white/35 font-medium" data-testid="fan-stories-disclaimer">{c.disclaimer}</p>
    </div>
  );
}
